import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AccessManagerCredentialsNotFoundError, AccessManagerUnaviableError, AccessManagerUserNotFoundError } from '../../auth/accessManager/accessManager.service';
import { LoggerService } from '../logging/logger.service';
import { GoogleTokenExpiredError, MissingGoogleTokenError } from 'src/app/auth/apigee/apigee.service';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
    constructor(private injector: Injector) {
        window.addEventListener("error", (error: any) => {
            this.handleError(error);
        });
    }

    public handleError(error: any): void {
        if (error.rejection && error.rejection.status == 0) {
            let router = this.injector.get(Router);
            location.replace(router.url);
        } else if (error instanceof AccessManagerCredentialsNotFoundError || (error.rejection && error.rejection instanceof AccessManagerCredentialsNotFoundError)) {
            let zone = this.injector.get(NgZone);
            let router = this.injector.get(Router);
            let logger = this.injector.get(LoggerService);
            logger.error(error.message);
            if (router.url != "/login") {
                zone.run(() => {
                    router.navigate(['login']);
                });
            }
        } else if (error instanceof AccessManagerUserNotFoundError || (error.rejection && error.rejection instanceof AccessManagerUserNotFoundError)) {
            let zone = this.injector.get(NgZone);
            let router = this.injector.get(Router);
            let logger = this.injector.get(LoggerService);
            logger.error(error.message);
            if (router.url != "/error") {
                zone.run(() => {
                    let errorRoute = router.config.find((value) => value.path == "error");
                    errorRoute.data = { errorMessage: error.rejection ? error.rejection.message || error.message : error.message, backLink: router.url, launcherEnabled: false, backLinkEnabled: false };
                    router.navigate(['error']);
                });
            }
        } else if (error instanceof AccessManagerUnaviableError || (error.rejection && error.rejection instanceof AccessManagerUnaviableError)) {
            let zone = this.injector.get(NgZone);
            let router = this.injector.get(Router);
            let logger = this.injector.get(LoggerService);
            logger.error(error.message);
            if (router.url != "/error") {
                zone.run(() => {
                    let errorRoute = router.config.find((value) => value.path == "error");
                    errorRoute.data = { errorMessage: error.rejection ? error.rejection.message || error.message : error.message, backLink: router.url, launcherEnabled: false, backLinkEnabled: true };
                    router.navigate(['error']);
                });
            }
        } else if (error instanceof GoogleTokenExpiredError || (error.rejection && error.rejection instanceof GoogleTokenExpiredError)
            || error instanceof MissingGoogleTokenError || (error.rejection && error.rejection instanceof MissingGoogleTokenError)) {
            let zone = this.injector.get(NgZone);
            let router = this.injector.get(Router);
            let logger = this.injector.get(LoggerService);
            logger.error(error.message);
            if (router.url != "/login") {
                zone.run(() => {
                    router.navigate(['login']);
                });
            }
        } else if (navigator.cookieEnabled) {
            let zone = this.injector.get(NgZone);
            let router = this.injector.get(Router);
            let logger = this.injector.get(LoggerService);
            logger.error(error.message);
            if (router.url != "/error") {
                zone.run(() => {
                    let errorRoute = router.config.find((value) => value.path == "error");
                    errorRoute.data = { errorMessage: error.rejection ? error.rejection.message || error.message : error.message, backLink: router.url, launcherEnabled: true, backLinkEnabled: true };
                    router.navigate(['error']);
                });
            }
        }
        else {
            alert('No están habilitadas las cookie de terceros, puedes hacerlo aquí:\nchrome://settings/cookies');
        }
    }
}
